import React, { useCallback, useMemo, useState } from 'react';
import SVGIcon from '../../../assets/images/svg/SVGIcon';
import {
  Assignbottom,
  Signmode,
  Assign,
  Div,
  HumanIcon,
  Assigngroup,
  AvatarImage,
  Rightrow1,
  RightText,
  Blankdiv
} from './styles';
import { useDispatch } from 'react-redux';
import Dropdown from '../../Dropdown/MainDropdown';
import { getRawComment, isEmpty } from '../../../helpers/common';
import { createNewComment, updateRecurringTaskDetails, updateTaskDetails } from '../../../services/taskServices';
import { COMMENT_TYPE } from '../../../global/constants';
import Avatar from '../../avatar/Avatar';
import DropdownItem from '../../Dropdown/DropdownItem';
import { ItemDiv } from '../../customContextMenu/styles';
// import { useParams } from 'react-router-dom';
import { TaskModel } from '../../../mobx/models/task';
import { observer } from 'mobx-react-lite';
import { UserModel } from '../../../mobx/models/user';
import { rootStore } from '../../../mobx/rootStore';
import { nanoid } from 'nanoid';

interface UserData {
  projectUsers: UserModel[];
  isHumanIcon?: boolean;
  currentTask?: TaskModel;
  isShowUnAssign?: boolean;
  currentAssignBox?: string;
  setCurrentAssignBox?: (id: string) => void;
  isPadding?: boolean;
  isCreateTaskModal?: boolean;
  setIsDropdownOpen?: Function;
  isMultiAssignee?: boolean;
  loadUser?: () => void;
  isContextMenu?: boolean;
  isRecurringTask?: boolean;
}

const AssignBoxV2: React.FC<UserData> = (props) => {
  const {
    projectUsers,
    currentTask,
    isShowUnAssign = false,
    setCurrentAssignBox,
    currentAssignBox,
    setIsDropdownOpen,
    isMultiAssignee,
    isCreateTaskModal,
    isHumanIcon = false,
    isPadding,
    loadUser,
    isContextMenu,
    isRecurringTask
  } = props;
  // States
  const [curentIndex, setCurrentIndex] = useState<number>(0);
  const [isSearch, setIsSearch] = useState(false);
  const [searchResult, setSearchResult] = useState<UserModel[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  //Mobx store variables
  const { taskStore, currentUser } = rootStore;
  const { createTaskInput } = taskStore;
  // Other variable
  const dispatch = useDispatch();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const dataRef = isSearch ? searchResult : projectUsers || [];

  const searchQuery = useCallback(
    (value: string) => {
      const result = projectUsers?.filter((item) => item?.name?.toLowerCase().includes(value?.toLowerCase())) || [];
      if (isEmpty(value)) setSearchResult(projectUsers || []);
      else setSearchResult(result);
      return null;
    },
    [projectUsers]
  );

  const onChangeSearch = useCallback(
    (value: string) => {
      let timeout;
      setCurrentIndex(0);
      if (!isEmpty(value)) {
        if (!isSearch) setIsSearch(true);
        if (timeout) clearTimeout(timeout);
        timeout = setTimeout(() => {
          searchQuery(value);
        }, 300);
      } else {
        if (isSearch) setIsSearch(false);
        searchQuery(value);
      }
    },
    [isSearch, searchQuery]
  );

  const closeDropdown = useCallback(() => {
    if (setIsDropdownOpen) setIsDropdownOpen(false);
    setCurrentAssignBox?.('');
    onChangeSearch('');
    setCurrentIndex(0);
  }, [onChangeSearch, setCurrentAssignBox, setIsDropdownOpen]);

  const onClickAssignUser = useCallback(
    async (user: UserModel) => {
      if (isCreateTaskModal) {
        const isAllReadyAssigned = createTaskInput.hasAssignee(user?.id);
        if (isAllReadyAssigned) {
          createTaskInput.removeAssignee(user?.id);
        } else {
          createTaskInput.addAssignee(user?.id);
        }
      } else {
        if (!currentUser) return;
        const isAllReadyAssigned = currentTask?.hasAssignee(user?.id);
        let newComment = {
          id: nanoid(),
          type: COMMENT_TYPE.ADD_ASSIGNEE,
          assigneeId: user?.id
        };
        if (isAllReadyAssigned) {
          currentTask?.removeAssignee(user?.id);
          newComment.type = COMMENT_TYPE.REMOVE_ASSIGNEE;
        } else {
          currentTask?.addAssignee(user?.id);
        }
        const updatedComment = getRawComment(newComment, currentUser);
        currentTask?.upsertComment(updatedComment);
        const payload = { taskUsers: currentTask?.usersIds, projectId: currentTask?.projectId };
        if (isRecurringTask) {
          await dispatch(updateRecurringTaskDetails(currentTask?.id, payload));
        } else {
          await dispatch(updateTaskDetails(currentTask?.id, payload));

          await dispatch(
            createNewComment(currentTask?.id, {
              Type: newComment.type,
              Assignee: user?.id
            })
          );
        }
      }
    },
    [createTaskInput, currentTask, currentUser, dispatch, isCreateTaskModal, isRecurringTask]
  );

  const onClickUnassignUser = useCallback(async () => {
    if (isCreateTaskModal) {
      createTaskInput.clearAssignees();
    } else {
      currentTask?.clearAssignees();
      const payload = { taskUsers: currentTask?.usersIds, projectId: currentTask?.projectId };
      await dispatch(updateTaskDetails(currentTask?.id, payload));
      await dispatch(
        createNewComment(currentTask?.id, {
          Type: COMMENT_TYPE.UNASSIGN
        })
      );
    }
  }, [createTaskInput, currentTask, dispatch, isCreateTaskModal]);

  const handlePlusIconClick = useCallback(() => {
    loadUser?.();
    setIsDropdownOpen?.(true);
    setCurrentAssignBox?.(currentTask?.id || '');
  }, [currentTask?.id, loadUser, setCurrentAssignBox, setIsDropdownOpen]);

  const renderSignModeContent = useCallback(() => {
    try {
      if (isHumanIcon && createTaskInput?.users) {
        if (createTaskInput?.users?.length > 0) {
          return (
            <Assign isCreateTaskModal={props?.isCreateTaskModal}>
              {createTaskInput?.users
                .filter((item) => !isEmpty(item?.id))
                .map((user) => (
                  <Div key={user?.id}>
                    <Avatar imgSrc={user?.profile_photo || ''} name={user?.name} size={16} isNotBorder />
                    <p>{user?.name}</p>
                  </Div>
                ))}
            </Assign>
          );
        } else {
          return (
            <HumanIcon isPadding={isPadding} isCreateTaskModal={props?.isCreateTaskModal}>
              <SVGIcon name='task-human-icon' width='16' height='16' viewBox='0 0 16 16' className='humanicon' />
              <p>Assignee</p>
            </HumanIcon>
          );
        }
      } else {
        if (isShowUnAssign) {
          if (currentTask?.users && currentTask.users.length > 0) {
            return (
              <Assigngroup>
                <ul>
                  {currentTask.users
                    ?.filter((item) => !isEmpty(item?.id))
                    ?.map((item) => (
                      <li key={item?.id}>
                        <AvatarImage>
                          <Avatar
                            imgSrc={item?.profile_photo || ''}
                            name={item?.name ? item?.name : 'U N'}
                            size={22}
                            isThinBorder
                          />
                        </AvatarImage>
                      </li>
                    ))}
                  <li className='plus-icon'>
                    <SVGIcon name='assign-plus-icon' width='24' height='24' viewBox='0 0 26 26' className='plus-icon' />
                  </li>
                </ul>
              </Assigngroup>
            );
          } else {
            return (
              <Rightrow1>
                <SVGIcon
                  name='unassign-profile-icon'
                  width='18'
                  height='18'
                  viewBox='0 0 18 18'
                  fill='var(--background-tertiary)'
                />
                <RightText>Unassigned</RightText>
              </Rightrow1>
            );
          }
        } else {
          return (
            <li className={currentAssignBox === currentTask?.id ? '' : 'plus-icon'} onClick={handlePlusIconClick}>
              <SVGIcon name='li-plus-icon' width='24' height='24' viewBox='0 0 24 24' className='fill-color' />
            </li>
          );
        }
      }
    } catch (error) {
      console.log('error', error);
    } finally {
      setIsLoading(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    isHumanIcon,
    createTaskInput?.users,
    props?.isCreateTaskModal,
    isPadding,
    isShowUnAssign,
    currentTask?.id,
    currentAssignBox,
    handlePlusIconClick
  ]);

  const handleKeyDown = useCallback(
    (e: React.KeyboardEvent<Element>) => {
      switch (e.key) {
        case 'ArrowUp':
          setCurrentIndex((prevIndex) => (prevIndex === 0 ? dataRef.length - 1 : prevIndex - 1));
          break;
        case 'ArrowDown':
          setCurrentIndex((prevIndex) => (prevIndex === dataRef.length - 1 ? 0 : prevIndex + 1));
          break;
        case 'Enter':
          onClickAssignUser(dataRef[curentIndex]);
          setCurrentIndex(0);
          break;
        case 'Escape':
          closeDropdown();
          break;
        default:
          break;
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [curentIndex, dataRef, closeDropdown, onClickAssignUser]
  );

  const renderData = useCallback(
    (data: UserModel[]) => {
      return (
        <div>
          <Assignbottom>
            <DropdownItem
              label={'Unassigned'}
              onClick={onClickUnassignUser}
              iconName={'unassign-profile-icon'}
              iconSize={20}
              iconViewBox='0 0 18 18'>
              {isMultiAssignee && <Blankdiv />}
            </DropdownItem>
            {data?.map((item, index: number) => {
              const isAssigned = isCreateTaskModal
                ? createTaskInput?.users?.some((user: { id: string }) => user.id === item.id)
                : currentTask?.users?.some((user: { id: string }) => user.id === item.id);
              return (
                <DropdownItem
                  key={index}
                  label={item?.name}
                  onClick={() => !isLoading && onClickAssignUser(item)}
                  isCheckBox={isMultiAssignee}
                  isAvatar={true}
                  avatarSrc={item?.profile_photo}
                  isChecked={isAssigned}
                  isActive={curentIndex === index}
                  isSelected={isAssigned}
                />
              );
            })}
          </Assignbottom>
        </div>
      );
    },
    [
      onClickUnassignUser,
      isMultiAssignee,
      isCreateTaskModal,
      createTaskInput?.users,
      currentTask?.users,
      curentIndex,
      isLoading,
      onClickAssignUser
    ]
  );

  const renderContent = useMemo(() => {
    return isContextMenu ? (
      <ItemDiv>
        <DropdownItem label='Assignee' iconName='task-human-icon' iconSize={16} />
      </ItemDiv>
    ) : (
      <Signmode>{renderSignModeContent()}</Signmode>
    );
  }, [isContextMenu, renderSignModeContent]);

  return (
    <div onKeyDown={(e) => handleKeyDown(e)}>
      <Dropdown
        isMinWidth={148}
        content={renderContent}
        trigger={isContextMenu ? 'hover' : 'click'}
        modalTitle='Assigns'
        onChangeSearch={onChangeSearch}
        onOutsideClick={() => {
          setCurrentAssignBox?.('');
        }}>
        {isSearch ? renderData(searchResult) : renderData(projectUsers?.filter((user) => !isEmpty(user?.id)) || [])}
      </Dropdown>
    </div>
  );
};
export default observer(AssignBoxV2);
